import IntegrationCallStepModelBase from '../_generated/modelBases/integration-call-step-model-base';

export default class IntegrationCallStepModel extends IntegrationCallStepModelBase {
  // For instructions on how to use Models visit:
  // https://glittrsoftware.visualstudio.com/glittr.core/_wiki/wikis/glittr.core.wiki/429/ServiceModels-DTOs
}
